module.exports = __webpack_public_path__ + "static/media/proj1.markdown.273d6213.md";